/**
 * Created by slava on 3/6/19
 */

const ColorHintAlgorithm = {
    type: "colorBooster",

    findMove: function () {
        if (!Game.currentGame || !Game.currentGame.field) {
            return;
        }

        const ideas = [
            ColorHintAlgorithm.feedEaterIdea,
            ColorHintAlgorithm.completeGoalIdea
        ];

        const move = HintHelper.findMove(ideas, cleverapps.Boosters.TYPE_COLOR);
        if (move) {
            move.type = ColorHintAlgorithm.type;
            move.delay = 3000;
            return move;
        }
    },

    completeGoalIdea: function (cell) {
        if (!HintHelper.isActiveGoal(cell)) {
            return;
        }

        const color = cell.getColor();
        if (!color) {
            return;
        }

        const goalId = cell.getGoalId();
        const remaining = HintHelper.countSameGoals(cell);

        const field = Game.currentGame.field;

        let colorTotal = 0;
        for (let i = 0; i < Field.SIZE; i++) {
            for (let j = 0; j < Field.SIZE; j++) {
                cell = field.cells[i][j];
                if (cell && cell.getColor() === color && cell.getGoalId() === goalId) {
                    colorTotal++;
                    const goalCoefComponent = cell.findComponent(GoalCoefComponent);
                    if (goalCoefComponent && goalCoefComponent.coef) {
                        colorTotal += goalCoefComponent.coef;
                    }
                }
            }
        }

        return colorTotal >= remaining;
    },

    feedEaterIdea: function (cell) {
        if (!Game.currentGame.EATERS || !cell.findComponent(ColorComponent)) {
            return;
        }

        const eater = HintHelper.getEater(cell.getColor());
        if (!eater) {
            return;
        }

        return eater.lives <= 10;
    }
};

AvailableMove.REGISTERED_ALGORITHMS.push(ColorHintAlgorithm);
